import { render, staticRenderFns } from "./Docks.vue?vue&type=template&id=6f2b5676"
import script from "./docks.js?vue&type=script&lang=js&external"
export * from "./docks.js?vue&type=script&lang=js&external"
import style0 from "./docks.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports